import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";

import { BaseDataService, HttpResponsesHandlersFactory } from "@bbwt/modules/data-service";
import { IPermission } from "./permission";
import { CoreRole } from "@main/roles";
import { Permissions } from "./permissions";

@Injectable({
    providedIn: "root"
})
export class PermissionService extends BaseDataService {
    readonly url = "api/permission";
    readonly entityTitle = "Permission";

    constructor(http: HttpClient, handlersFactory: HttpResponsesHandlersFactory) {
        super(http, handlersFactory);
    }

    getAll(): Promise<IPermission[]> {
        return this.handleRequest<IPermission[]>(this.http.get<IPermission[]>(this.url), this.handlersFactory.getDefault());
    }

    updatePermissionsByRoles(
        permissions: IPermission[],
        roles: string[],
        checkIfEnabledInPairWithMasterPermission: (string) => boolean = null
    ): IPermission[] {
        return permissions?.map(permission => {
            if (
                permission.name === Permissions.RegisterPatient ||
                (checkIfEnabledInPairWithMasterPermission != null && checkIfEnabledInPairWithMasterPermission(permission.name))
            ) {
                return { ...permission, disabled: true };
            }

            if (
                permission.name === Permissions.ReadNHSData &&
                !roles?.some(r =>
                    [
                        CoreRole.Doctor.toString(),
                        CoreRole.ClinicalAdmin.toString(),
                        CoreRole.Therapist.toString(),
                        CoreRole.SuperAdmin.toString(),
                        CoreRole.MiProAdmin.toString()
                    ].includes(r)
                )
            ) {
                return { ...permission, disabled: true };
            }

            return permission;
        });
    }

    getUserOrganizationsFormPermissions(userId: string) {
        return this.handleRequest(
            this.http.get<{ [orgId: string]: IPermission[] }>(`${this.url}/user-organization-formio/${userId}`),
            this.handlersFactory.getDefault()
        );
    }

    getOrganizationFormPermissions(organizationId: string) {
        return this.handleRequest(
            this.http.get<IPermission[]>(`${this.url}/organization-formio/${organizationId}`),
            this.handlersFactory.getDefault()
        );
    }
}
